import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Selectsearch from "react-select";
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   allStudents,
   fetchPuttPerformanceChart,
   deletePuttPerformance,
   studentPuttPerformance,
   fetchPuttPerformance,
} from 'Actions';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';
import ViewChart from './component/rightchart';
import StrokesChart from './component/strokeschart';
import PuttOneChart from './component/puttone';
import PuttTwoChart from './component/putttwo';
import PuttThreeChart from './component/puttthree';
import StrokesLine from './component/strokesline';

import AddItem from '../puttperformance/component/addform';
import EditItem from '../puttperformance/component/editform';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class puttchart extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
      let startDate = new Date();
      let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
      this.confirmationDialog = React.createRef();
         this.state = {
            student:'',
            startdate:befrstart,
            enddate:new Date(),
            viewdiv1:true,
            viewdiv2:false,
            viewdiv3:true,
            viewdiv4:true,
            loader:false, 
            adddiv:false,
            viewdiv:true,
            listdiv:false,
            editdiv:false,
            sepmore:1,
            totavgpoints:0,
            formValues: [{ puttlength:"", noputt:"", putttype:"", right : "", left : "", short : "", long : "", avgputt:"", strokes:"", disright:"", disleft:"", disshort:"", dislong:""}],
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.onEditBack = this.onEditBack.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.viewList = this.viewList.bind(this);
   } 

   UNSAFE_componentWillMount() {
	   this.props.allStudents();
	} 

   selstudent(evt){
        var student=evt.value;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');       
        var distance='';
        var puttype='';
        this.setState({ 
            loader:true,
            student: student,  
            viewdiv2:false,
        }); 
       
        this.props.fetchPuttPerformanceChart(student, stdate, eddate, distance, puttype).then((data) => {   
                    
            this.setState({ 
                loader:false,
                viewdiv2:true,  
            });

        });
        
    }

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');       
        this.setState({ 
            loader:true,
            viewdiv2:false,
        });
        
       
        this.props.fetchPuttPerformanceChart(student, stdate, eddate).then((data) => {   
            var resdata=data.data;            
            this.setState({ 
                loader:false,
                viewdiv2:true,  
            });

        });
    }   
    
    addEntry(){
        this.setState({ 
            adddiv:true,
            viewdiv2:false,
            
       });
    }

    viewList(){
        var stdid=this.state.student;
        var start='';
        var end='';
        this.props.studentPuttPerformance(stdid, start, end).then((data) => {   
            
            this.setState({ 
                viewdiv2:false,
                listdiv:true
            });

        });
        
    }

    onBackSection() {
		this.setState({ 
            adddiv:false,
            listdiv:false,
            viewdiv2:true,
       });
	}
    
    onEditBack() {
		this.setState({ 
            adddiv:false,
            editdiv:false,
            listdiv:true,
       });
	}

    editAssessment(assmval){
        
        var id=assmval.gpp_userID;
        var date=assmval.gpp_date;
          
          this.props.fetchPuttPerformance(id, date).then((data) => {   
              var resdata=data.data;
              var troptobj=[]; 
              var st=0;
              {resdata.map((teamval) => (   
  
                 troptobj.push({
                    puttlength:teamval.gpp_puttlength,
                    noputt:teamval.gpp_noputt,
                    putttype:teamval.gpp_putttype,
                    right: teamval.gpp_right,
                    left: teamval.gpp_left,
                    short: teamval.gpp_short,
                    long: teamval.gpp_long,
                    avgputt:teamval.gpp_avgputt,
                    strokes: teamval.gpp_strokes,
                    disright:teamval.gpp_right==0 ? 0 : 1, 
                    disleft:teamval.gpp_left==0 ? 0 : 1, 
                    disshort:teamval.gpp_short==0 ? 0 : 1, 
                    dislong:teamval.gpp_long==0 ? 0 : 1,                  
  
                 }),
                 st=parseFloat(st)+parseFloat(teamval.gpp_strokes)
              ))} 
  
              var totavg=parseFloat((st/resdata.length).toFixed(4));
              this.setState({ 
                 seldate:resdata[0].gpp_date, 
                 student:resdata[0].gpp_userID,
                 formValues:troptobj,
                 sepmore:resdata.length,
                 totavgpoints:totavg
              });
  
              this.setState({ 
                  viewdiv:false,  
                  listdiv:false,              
                  adddiv:false,
                  editdiv:true,
              });
  
          });
      }
  
      deleteForm(assmval){
        this.id = assmval.gpp_userID;
        this.date = assmval.gpp_date;
        this.confirmationDialog.current.openDialog();
      }
  
     deleteDataPermanent(popupResponse){
        
           if (popupResponse) {
              this.props.deletePuttPerformance(this.id, this.date);
              this.data = ""
           }
     }
   

    render() {
      const { match, studentlists, puttperformancelist, loading } = this.props;

      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });

      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
    };

    const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
        
    ];
        const tabledata=puttperformancelist.map((assmntval,idx) => {     
            const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
            const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                action: ebtn,
                action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Putt Performance Report | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.puttperformancereport" />} match={match} />
             <div className="row">
                        <div className="col-sm-12 col-lg-4">
                            <RctCollapsibleCard> 
                                <div className="row">                                        
                                    <div className="col-sm-12 col-lg-12"> 
                                        <FormGroup>
                                            <Label for="Select">Student *</Label>
                                            <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                        </FormGroup>
                                    </div>                                     
                                </div>
                            </RctCollapsibleCard>  
                        </div>
                        {this.state.viewdiv1 &&                             
                            <div className="col-sm-12 col-lg-6">
                                <RctCollapsibleCard>                              
                                    <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                        <div className="row">                                                    
                                            <div className="col-lg-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                            selected={this.state.startdate}
                                                            onChange={this.selectstart}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown 
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="col-lg-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                            selected={this.state.enddate}
                                                            onChange={this.selectend}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="form-group">                       
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                            </div>              
                                        </div>
                                    </form>  
                                </RctCollapsibleCard>                                                    
                            </div>
                        }
                </div>
               {this.state.viewdiv2 && 
                 <>
                  <ViewChart onClick={this.addEntry} onClick1={this.viewList} data={this.state}/>
                  <StrokesChart data={this.state}/>
                  <StrokesLine data={this.state}/>
                  <PuttOneChart data={this.state}/>
                  <PuttTwoChart data={this.state}/>
                  <PuttThreeChart data={this.state}/>
                 </>
               }

                {this.state.adddiv&&
                    <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.listdiv &&
                    <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="PUTT PERFORMANCE LIST" fullBlock>
                            <MUIDataTable    
                                    title={<div><Button onClick={ ()=>this.onBackSection()} className="btn btn-outline-warning"> Back</Button></div>}                               
                                    data={tabledata}
                                    columns={columns}
                                    options={options} 
                            />   
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.editdiv && 
                  <EditItem onClick={this.onEditBack} data={this.state}/>              
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'putt performance'}
                />

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }

                               
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, puttperformance }) => {
	const { studentlists, loading } = mostlyused;
    const { puttperformancelist } = puttperformance;
	return { studentlists, puttperformancelist, loading };
}

export default connect(mapStateToProps, {
   allStudents,
   fetchPuttPerformanceChart,
   deletePuttPerformance,
   studentPuttPerformance,
   fetchPuttPerformance,
})(puttchart); 